import { IResponse } from "@core/data-access/model";
import { UrlUtil } from "@core/utils";
import { HttpRequestUtil, IRequestConfig } from "@core/utils/http-request-util";
import { envConfig } from "@env/env-config";
import { IProductCatalog, productCatalogWithPagePath } from "./product-catalog/model/domain/ProductCatalog";
import { IPageObjectTreeService } from "@modules/basic/page";

export type defaultCatalogRes = {
    success: boolean,
    defaultCatalog: IProductCatalog,
    customizePath: string
}

export class DefaultCatalogUtil {
    // 缓存15分钟 
    private static readonly CACHE_TIME: number = 900 * 1000; // (转换为ms)
    // 缓存key
    private static readonly DEFAUKT_CATALOG_KEY = "DefaultCatalog";
    private static readonly DEFAUKT_CATALOG_EXPIRE_KEY = "CatalogList-Expire";
    public static readonly CUSTOMIZE_PATH = "customize/";

    public static getDefaultCatalog(objectTree: IPageObjectTreeService, $q: angular.IQService): angular.IPromise<defaultCatalogRes> {
        const defer = $q.defer<defaultCatalogRes>();

        let defaultCatalogObj = objectTree.getCache(DefaultCatalogUtil.DEFAUKT_CATALOG_KEY);

        // storage中无默认分类数据
        if (!defaultCatalogObj) {
            let retCatalog = DefaultCatalogUtil.getDefaultCatalogByRest(objectTree, $q);

            retCatalog.then(function (res) {
                defer.resolve({
                    success: true,
                    defaultCatalog: res.defaultCatalog,
                    customizePath: DefaultCatalogUtil.CUSTOMIZE_PATH
                })
            }, function (error) {
                defer.reject(error)
            })
        } else {
            // storage中有默认分类数据
            let currentDate = new Date().getTime();
            let expireTime = objectTree.getCache(DefaultCatalogUtil.DEFAUKT_CATALOG_EXPIRE_KEY);
            // 获取默认类目缓存 
            const defaultCatalog = objectTree.getCache(DefaultCatalogUtil.DEFAUKT_CATALOG_KEY);
            // 超过缓存时间
            if (currentDate > Number(expireTime) || !defaultCatalog) {
                let retCatalog = DefaultCatalogUtil.getDefaultCatalogByRest(objectTree, $q);

                retCatalog.then(function (res) {
                    defer.resolve({
                        success: true,
                        defaultCatalog: res.defaultCatalog,
                        customizePath: DefaultCatalogUtil.CUSTOMIZE_PATH
                    })
                }, function (error) {
                    defer.reject(error)
                })
            } else {
                // 未超过缓存时间
                let defaultCatalog = objectTree.getCache(DefaultCatalogUtil.DEFAUKT_CATALOG_KEY);
                if (defaultCatalog) {
                    let defaultCatalogParse = angular.fromJson(defaultCatalog) as IProductCatalog;

                    defer.resolve({
                        success: true,
                        defaultCatalog: defaultCatalogParse,
                        customizePath: DefaultCatalogUtil.CUSTOMIZE_PATH
                    })
                }
            }
        }

        return defer.promise;
    }

    private static getDefaultCatalogByRest(objectTree: IPageObjectTreeService, $q: angular.IQService): angular.IPromise<defaultCatalogRes> {
        const defer = $q.defer<defaultCatalogRes>();

        let httpUtil = new HttpRequestUtil();

        const appPath = envConfig.appPath("base");
        const token = objectTree.token;

        if (!token) {
            throw new Error("Missing Token");
        }

        let requestUrl = objectTree.USE_TEST_VERSION ?
            UrlUtil.joinUrl([appPath, "/api/config/default/productCategory/test"]) :
            UrlUtil.joinUrl([appPath, "/api/config/default/productCategory/release"]);

        const requestCfg: IRequestConfig = {
            method: "get",
            url: requestUrl,
            authorization: `${token.token_type} ${token.access_token}`
        }

        httpUtil.request(requestCfg, function (res: IResponse<IProductCatalog>) {
            if (res.success) {
                let resData = res.data;
                let pagePathStr: string;
                //TODO（待替换为pageNameFilter） 使用分类名获得pageUrl (去除pageName中的".html")
                resData.catalog.pageName = resData.catalog.pageName.replace('.html', '');
                pagePathStr = resData.catalog.pageName;
                (resData as productCatalogWithPagePath).pagePath = pagePathStr + '/all';

                objectTree.setCache(DefaultCatalogUtil.DEFAUKT_CATALOG_KEY, JSON.stringify(resData));

                const expireDate = new Date().getTime() + DefaultCatalogUtil.CACHE_TIME;
                objectTree.setCache(DefaultCatalogUtil.DEFAUKT_CATALOG_EXPIRE_KEY, expireDate.toString());

                defer.resolve({
                    success: true,
                    defaultCatalog: resData,
                    customizePath: DefaultCatalogUtil.CUSTOMIZE_PATH
                })
            } else {
                defer.reject(res);
            }
        }, function (error) {
            defer.reject(error);
        })

        return defer.promise;
    }
}